module.exports = __webpack_public_path__ + "static/img/02042D_5_6_C_20240426_fit.264139b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02042D_5_6_C_20240426_fit.png
// module id = 2n2v
// module chunks = 0